import GiftingMiddleware from '@/middleware/GiftingMiddleware';

export default [
    {
        path: 'choose-your-gift',
        name: 'account.gifting.choose-your-gift',
        beforeEnter: GiftingMiddleware,
        component: () => import(/* webpackChunkName: "gifting" */ '@/views/account/gifting/ChooseGiftType.vue'),
        meta: {
            navigation: {
                title: 'Choose your gift',
            },
        },
    },
    {
        path: 'choose-your-box-type',
        name: 'account.gifting.choose-your-box-type',
        beforeEnter: GiftingMiddleware,
        component: () => import(/* webpackChunkName: "gifting" */ '@/views/account/gifting/ChooseYourBoxType.vue'),
        meta: {
            navigation: {
                title: 'Choose a size',
            },
        },
    },
    {
        path: 'number-of-deliveries',
        name: 'account.gifting.number-of-deliveries',
        beforeEnter: GiftingMiddleware,
        component: () => import(/* webpackChunkName: "gifting" */ '@/views/account/gifting/NumberOfDeliveries.vue'),
        meta: {
            navigation: {
                title: 'Number of deliveries',
            },
        },
    },
    {
        path: 'delivery-address',
        name: 'account.gifting.delivery-address',
        beforeEnter: GiftingMiddleware,
        component: () => import(/* webpackChunkName: "gifting" */ '@/views/account/gifting/DeliveryAddress.vue'),
        meta: {
            navigation: {
                title: 'Delivery address',
            },
        },
    },
    {
        path: 'freddies-addons',
        name: 'account.gifting.freddies-addons',
        beforeEnter: GiftingMiddleware,
        component: () => import(/* webpackChunkName: "gifting" */ '@/views/account/gifting/FreddiesAddons.vue'),
        meta: {
            navigation: {
                title: 'Extras!',
            },
        },
    },
    {
        path: 'freddies-shop',
        name: 'account.gifting.freddies-shop',
        beforeEnter: GiftingMiddleware,
        component: () => import(/* webpackChunkName: "gifting" */ '@/views/account/gifting/FreddiesShop.vue'),
        meta: {
            navigation: {
                title: 'Extras!',
            },
        },
    },
    {
        path: 'delivery-day',
        name: 'account.gifting.delivery-day',
        beforeEnter: GiftingMiddleware,
        component: () => import(/* webpackChunkName: "gifting" */ '@/views/account/gifting/DeliveryDay.vue'),
        meta: {
            navigation: {
                title: 'Delivery date',
            },
        },
    },
    {
        path: 'gift-card',
        name: 'account.gifting.gift-card',
        beforeEnter: GiftingMiddleware,
        component: () => import(/* webpackChunkName: "gifting" */ '@/views/account/gifting/GiftCard.vue'),
        meta: {
            navigation: {
                title: 'Personalised card',
            },
        },
    },
    {
        path: 'payment',
        name: 'account.gifting.payment',
        beforeEnter: GiftingMiddleware,
        component: () => import(/* webpackChunkName: "gifting" */ '@/views/account/gifting/Payment.vue'),
        meta: {
            navigation: {
                title: 'Payment details',
            },
        },
    },
    {
        path: 'thank-you',
        name: 'account.gifting.thank-you',
        beforeEnter: GiftingMiddleware,
        component: () => import(/* webpackChunkName: "gifting" */ '@/views/account/gifting/SaveGiftingReminder.vue'),
        meta: {
            navigation: {
                title: 'All done!',
            },
        },
    },
];
